<script>
import MinimalLayout from '@/components/layouts/minimal/MinimalLayout';
import animate from '@/modules/animate-css';

export default {
  name: 'Login',
  components: {
    MinimalLayout
  },
  metaInfo() {
    return { title: this.title };
  },
  data() {
    return {
      title: this.$t('Login'),
      token: '',
      invalid: [],
      isRecovering: false,
      isTrusted: false,
      password: ''
    };
  },
  mounted() {
    this.$refs.token.focus();
  },
  methods: {
    handleSubmit() {
      this.invalid = [];
      this.isRecovering = true;

      // Log the user in
      this.$http
        .post('/auth/tfa/recover', {
          token: this.token
        })
        .then(() => {
          // Set two-factor auth status
          this.$store.commit('setUser', Object.assign({}, this.$store.state.user, { requiresTfa: false }));
          this.$store.commit('setTfa', {
            isRequiredByAccount: this.$store.state.user.account.requiresTfa,
            isRequired: false,
            isVerified: false
          });

          // Redirect
          this.$router.push({ name: 'EnableTfa' });
        })
        .catch(err => {
          const data = err.response.data;
          const status = err.response.status;

          if (status === 400) {
            this.invalid = Array.isArray(data.invalid) ? data.invalid : [];
            animate(document.querySelector('.minimal-body'), 'shake', 1.25);
          } else {
            this.$notify({
              type: 'error',
              title: this.$t('Error'),
              message: this.$t('An error occurred. Please try your request again later.')
            });
          }
        })
        .finally(() => (this.isRecovering = false));
    }
  }
};
</script>

<template>
  <minimal-layout>
    <el-form ref="loginForm" label-position="top" @submit.native.prevent="handleSubmit">
      <p>
        {{ $t('Please enter the recovery code you were given when you enabled two-factor authentication.') }}
      </p>

      <!-- Recovery Token -->
      <el-form-item :class="{ 'is-error': invalid.includes('token') }" :label="$t('Recovery Code')">
        <el-input ref="token" v-model="token" type="text" auto-complete="off" />
      </el-form-item>

      <!-- Recover -->
      <el-form-item>
        <el-button :loading="isRecovering" type="primary" native-type="submit" class="el-button--block">
          {{ $t('Recover My Account') }}
        </el-button>
      </el-form-item>

      <!-- Back link -->
      <div class="text-center">
        <small>
          <router-link :to="{ name: 'LoginTfa' }">
            {{ $t('Back') }}
          </router-link>
        </small>
      </div>
    </el-form>
  </minimal-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

//
// No styles yet
//
</style>
